import Button, { ButtonProps } from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import * as React from 'react';

const useStyles = makeStyles(theme => ({
  button: {
    display: 'block',
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
    fontWeight: 'normal',
    textTransform: 'none',
    textAlign: 'left',
    ...theme.typography.body1
  }
}));

export interface Props {
  currentOption: string;
  availableOptions: string[];
  onSelect: (currentOption: string) => void;
}

const TextDropdownButton: React.FC<Props & ButtonProps> = ({
  currentOption,
  availableOptions,
  onSelect,
  className,
  ...buttonProps
}) => {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleItemClose = (selectedOption: string) => {
    onSelect(selectedOption);
    setAnchorEl(null);
  };

  return (
    <>
      <Button
        className={clsx(classes.button, className)}
        variant="text"
        aria-controls="simple-menu"
        aria-haspopup="true"
        onClick={handleClick}
        {...buttonProps}
      >
        {currentOption}
      </Button>
      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted={true}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
        getContentAnchorEl={null}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center'
        }}
      >
        {availableOptions.map(availableOption => {
          // TODO return null when there are no available options left to click (showing empty box)
          return (
            <MenuItem key={availableOption} onClick={handleItemClose.bind(null, availableOption)}>
              {availableOption}
            </MenuItem>
          );
        })}
      </Menu>
    </>
  );
};

export default TextDropdownButton;
